import { useTranslation } from 'react-i18next';
import { Table, Theme } from '../';
import type { TableProps } from '../';
import type { TableContainerProps } from './types/propsTypes';
import styles from './TableContainer.module.scss';

const TableContainer = ({
  onRowClick,
  getColumns,
  cb,
  isAdmin = false,
  dataSource,
  theme = Theme.BLACK,
  searchKey,
  hideSearchFilter = false,
  displayOverflow,
  getBulkActions,
  ...restProps
}: TableContainerProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles['product-list-view-container']}>
      <div className={styles['table-container']}>
        <Table
          key={`${dataSource?.[0]?.recId}_${searchKey}_${dataSource?.length}`} // Hack: to refresh stale pagination data
          theme={theme}
          columns={getColumns(styles, t, cb, isAdmin) as TableProps['columns']}
          dataSource={dataSource}
          pagination
          rowKey="productId"
          onRowClick={onRowClick}
          hideSearchFilter={hideSearchFilter}
          displayOverflow={displayOverflow}
          bulkActionOption={getBulkActions?.(cb) as TableProps['bulkActionOption']}
          {...restProps}
        />
      </div>
    </div>
  );
};

export default TableContainer;
export type { TableContainerProps };
